/* PATOYS homepage: accessible product tabs. Without JavaScript every panel is shown stacked. */
(function () {
  document.querySelectorAll('[data-pt-tabs]').forEach(function (root) {
    var buttons = Array.prototype.slice.call(root.querySelectorAll('[role="tab"]'));
    var panels = Array.prototype.slice.call(root.querySelectorAll('[role="tabpanel"]'));
    if (!buttons.length || buttons.length !== panels.length) return;

    function select(index, focus) {
      buttons.forEach(function (btn, i) {
        var on = i === index;
        btn.setAttribute('aria-selected', String(on));
        btn.tabIndex = on ? 0 : -1;
        panels[i].classList.toggle('is-active', on);
      });
      if (focus) buttons[index].focus();
    }

    buttons.forEach(function (btn, i) {
      btn.addEventListener('click', function () {
        select(i, false);
      });
      btn.addEventListener('keydown', function (e) {
        var next = null;
        if (e.key === 'ArrowRight') next = (i + 1) % buttons.length;
        if (e.key === 'ArrowLeft') next = (i - 1 + buttons.length) % buttons.length;
        if (e.key === 'Home') next = 0;
        if (e.key === 'End') next = buttons.length - 1;
        if (next !== null) {
          e.preventDefault();
          select(next, true);
        }
      });
    });

    root.classList.add('is-ready');
    select(0, false);
  });
})();